<template>
  <v-list-item>
    <v-row>
      <v-col cols="6" sm="8" lg="10">
        <v-list-item-content>
          <v-list-item-title v-text="product.name" />
          <v-list-item-subtitle v-text="product.description" />
          <v-list-item-subtitle>
            kr {{ product.price }},-
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-col>

      <v-col cols="6" sm="4" lg="2">
        <v-text-field
          v-model="quantity"
          label="Antall"
          solo
          prepend-icon="mdi-minus"
          append-outer-icon="mdi-plus"
          style="margin-left: auto; margin-right: 0"
          class="quantity-input mt-2"
          @click:append-outer="incrementQuantity"
          @click:prepend="decrementQuantity"
          @change="updateQuantity"
        />
      </v-col>
    </v-row>
  </v-list-item>
</template>

<style scoped>
.quantity-input {
  max-width: 130px;
  min-width: 80px;
  text-align: center;
}

.v-list-item__subtitle,
.v-list-item__title {
  white-space: normal;
}
</style>

<script>
export default {
  name: "VendorProduct",

  props: {
    product: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      quantity: 0,
    };
  },

  methods: {
    updateQuantity() {
      this.$emit("change-quantity", {
        product: this.product,
        quantity: this.quantity,
      });
    },
    decrementQuantity() {
      if (this.quantity > 0) {
        this.quantity--;

        this.$emit("change-quantity", {
          product: this.product,
          quantity: this.quantity,
        });
      }
    },

    incrementQuantity() {
      this.quantity++;

      this.$emit("change-quantity", {
        product: this.product,
        quantity: this.quantity,
      });
    },
  },
};
</script>
